import { motion, AnimatePresence } from 'framer-motion'
import VideoPlayer from 'react-player/vimeo'

import styles from './Signup.module.css'

const SignupVideo = ({ step }) => {
  return (
    <AnimatePresence initial={false} className={styles['step-video-wrapper']}>
      <motion.div
        key={step}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duraton: 1 }}
        style={{ height: '100%' }}
      >
        <div className={styles['step-video']}>
          <VideoPlayer
            url={step.video}
            className={styles['step-video-player']}
            width="100%"
            height="100%"
            controls
            playsinline={true}
            loop={true}
            config={{
              vimeo: {
                playerOptions: {
                  width: 1280,
                  height: 720,
                  background: true,
                  loop: true,
                },
              },
            }}
          />
        </div>
      </motion.div>
    </AnimatePresence>
  )
}

export default SignupVideo
